import type { SaveState } from "../hooks/useDraft.js";

/**
 * Autosave is invisible when it works, so the only job here is to be honest
 * when it does not. "Saved" is never shown optimistically — only after the
 * server confirmed.
 */
export const SaveIndicator = ({ state }: { state: SaveState }) => {
  switch (state.status) {
    case "saving":
      return <span className="text-xs text-faint">Saving…</span>;
    case "saved":
      return <span className="text-xs text-faint">Saved</span>;
    case "conflict":
      return (
        <span className="text-xs font-medium text-amber-700">
          Edited elsewhere
        </span>
      );
    case "error":
      return (
        <span
          role="status"
          className="text-xs font-medium text-danger"
          title={state.message}
        >
          Not saved
        </span>
      );
    case "clean":
      return null;
  }
};
